import { EDecorationType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDecorationsListFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const DecorationsListContainer: FC = () => {
  const { label, value, options } = useSelector(selectDecorationsListFilter);

  const onChange = useFilterChangeCallback();

  const handleDecorationsListChange = useCallback(
    (newValue: NonEmptyArray<EDecorationType> | null) => {
      onChange({ action: 'setDecorationsList', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleDecorationsListChange} />
    </AdvancedFilterRow>
  );
};
